/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import { useTheme } from '../../../providers/theme';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { vappContainer } from '@/application';
import { PaymentPageService } from '../services';
import { PaymentComp, PaymentSummary } from '../components';
import { Header } from '../components';
import { useSMCreateSession } from '../machines/createCheckoutSession';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { useSMCheckStatus } from '../machines/checkStatus';
import { InfinitySpin, Hourglass } from 'react-loader-spinner';
import './styles.css';
import { useSMGetFee } from '../machines';
import { Loader } from '@/components';
import { AppNavigatorService } from '@/AppNavigator';
import { useSMAppNavigator } from '@/AppNavigator/machines/pageContent';
const getSrv = () => {
  return vappContainer.get<PaymentPageService>(PaymentPageService.displayName);
};

const getAppSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const { createSessionSend, createSessionState } = useSMCreateSession({});
  const { appNavigatorSend } = useSMAppNavigator({});
  const { getFeeSend, getFeeState } = useSMGetFee({});
  const { checkStatusSend, checkStatusState } = useSMCheckStatus({});
  const [iframeCreated, setIframeCreated] = useState(false);
  const [spinnerLoading, setSpinnerLoading] = useState(true);
  const onPaymentSubmit = (data: any) => {
    console.log(`register submit`, data);
  };
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showIframe, setShowIframe] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isMounted, setIsMounted] = useState(false);
  const redirectData = createSessionState?.event?.data?.value?.RedirectData;
  console.log('Redirection Data', redirectData);
  const iframeRef = useRef(null);
  useEffect(() => {
    setShowIframe(true);
  }, [redirectData]);

  // const handleMessageFromIframe = (event) => {
  //   const iframeUrl = event.data;
  //   console.log('Received URL from iframe:', iframeUrl);
  // };

  // useEffect(() => {
  //   window.addEventListener('message', handleMessageFromIframe);

  //   return () => {
  //     window.removeEventListener('message', handleMessageFromIframe);
  //   };
  // }, []);

  const spinner = async () => {
    setSpinnerLoading(true);
    // document.getElementById('spinner')?.style.display = 'none';
    setTimeout(() => {
      setSpinnerLoading(false);
      if (document.getElementById('spinner')) {
        document.getElementById('spinner').style.display = 'flex';
      }
    }, 10000);
  };

  console.log(
    'getFeeState?.event?.data?.value?.data?',
    getFeeState?.event?.data?.value?.data
  );

  const openIframe = () => {
    setShowIframe(true);
  };

  const handleIframeLoad = () => {
    setIsMounted(true);
  };

  // async function fetchSidebarItems() {
  //   try {

  //     // Call the getSidebarItems method
  //     const srv = getAppSrv();
  //     const sidebarItems = await srv.getSidebarItems();

  //     // Now 'sidebarItems' contains the data you fetched
  //     console.log('Fetched Sidebar Items:', sidebarItems);
  //   } catch (error) {
  //     console.error('Error fetching sidebar items:', error);
  //   }
  // }

  const closeIframe = () => {
    // setShowIframe(false);
    // fetchSidebarItems()
    appNavigatorSend('TRIGGER_REFRESH', {});
    navigate(`/applications-being-processed`);
  };

  const onSubmit = (data: any) => {
    const cardDetail = {
      cardExp: data?.expiry,
      cardHolderName: data?.name,
      cvv: data?.cvc,
      cardPan: data?.number?.replace(/\s/g, ''),
    };
    createSessionSend('START', {
      payload: {
        cardDetail,
        price: getFeeState?.event?.data?.value?.data?.price,
      },
    });
  };
  const _renderErrors = () => {
    if (
      createSessionState?.matches('CREATE_SESSION_FAILED') ||
      checkStatusState?.matches('CHECK_SESSION_FAILED') ||
      getFeeState?.matches('GET_FEE_FAILED')
    ) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.createSession || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };

  const _renderNotification = () => {
    if (createSessionState?.matches('CHECK_SESSION_SUCCESS')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.notifications?.createSessionSuccess ||
            {})}
          onAcknowledgement={() => {}}
          onDeny={onRefresh}
        />
      );
    }
    return null;
  };

  const _renderPage = () => {
    if (createSessionState?.matches('CREATE_SESSION')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.createSession || {})} />
      );
    }
    if (getFeeState?.matches('GET_FEE')) {
      return <Loader {...(staticPageContentConfig?.loading?.getFee || {})} />;
    }

    if (redirectData) {
      return (
        <div>
          {/* <button onClick={openIframe}>Open Iframe</button> */}

          {showIframe && (
            <div className="iframe-overlay">
              <div className="iframe-container">
                {!spinnerLoading && (
                  <div className="close-button-container">
                    <button onClick={closeIframe} className="close-button">
                      Close
                    </button>
                  </div>
                )}
                <div
                  id="spinner"
                  className="spinner-overlay"
                  style={{
                    background: 'white',
                    padding: '20px',
                    flexDirection: 'column',
                  }}
                >
                  <Hourglass
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="hourglass-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    colors={['#306cce', '#72a1ed']}
                  />
                  <p style={{ textAlign: 'center', marginTop: '10px' }}>
                    Payment processing. Please do not refresh the page or click
                    "Back" or "Close" button of your browser.
                  </p>
                </div>
                <iframe
                  className="fullscreen-iframe"
                  srcDoc={redirectData}
                  ref={iframeRef}
                  onLoad={spinner}
                ></iframe>
              </div>
            </div>
          )}
        </div>
      );
    }
    console.log('li->', getFeeState?.event?.data?.value?.data);
    if (getFeeState?.matches('GET_FEE_SUCCESS'))
      return (
        <>
          <PaymentComp
            onSubmit={onSubmit}
            paymentSummaryConfig={{
              ...staticPageContentConfig?.paymentSummaryConfig,
              prices: getFeeState?.event?.data?.value?.data,
            }}
          />
        </>
      );
    // }
  };

  const onRefresh = () => {
    console.log('li->');
    getFeeSend('TRIGGER_REFRESH', {});
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onRefreshClick={onRefresh}
          />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      {/* {_renderModal()} */}

      {_renderErrors()}
      {_renderNotification()}
      {_renderPage()}
    </>
  );
};
